export default {
  namespaced: true,
  hanwha_alarm_profile: {
    title: 'Perfil de alarmes Hanwha | Perfis de alarmes Hanwha',
    name: 'Nome', description: 'Descrição', enabled: 'Ativado', rules: 'Regras', dvrs: 'DVRs atribuídos',
  },
  hanwha_alarm_rule: {
    title: 'Regra de alarme Hanwha | Regras de alarmes Hanwha',
    type_log: 'Tipo de log', event_type: 'Evento de alarme', recovery_event_type: 'Evento de restauração', channel: 'Canal',
    alarm_type: 'Tipo de alarme', target: 'Destino', alarm_message: 'Mensagem de alarme', recovery_message: 'Mensagem de restauração',
    delay_seconds: 'Atraso (segundos)', priority: 'Prioridade', any_channel: 'Qualquer canal', dvr: 'DVR', camera: 'Câmera', enabled: 'Ativada',
  },
}
